import { ConfigProvider, TimePicker } from 'antd';
// import { PRIMARY_ORANGE_COLOR, SECONDARY_ORANGE_COLOR } from '../../utils/utils';

const MyTimePicker = (props) => {
    const { className, ...rest } = props;

    // const handleChange = (time, timeString) => {
    //     console.log(time, timeString);
    //     onChange(timeString);
    // };

    return (
        <ConfigProvider
            theme={{
                components: {
                    DatePicker: {
                        // activeBorderColor: PRIMARY_ORANGE_COLOR,
                        // hoverBorderColor: SECONDARY_ORANGE_COLOR,
                    },
                    token: {
                        // colorLink: SECONDARY_ORANGE_COLOR,
                        // colorLinkActive: PRIMARY_ORANGE_COLOR,
                        // colorLinkHover: PRIMARY_ORANGE_COLOR,
                    }
                },
            }}
        >
                <TimePicker 
                    // onChange={handleChange} 
                    // defaultValue={dayjs('00:00:00', 'HH:mm:ss')} 
                    // value={value}
                    className={`custom-timepicker ${className}`}
                    {...rest}
                />
        </ConfigProvider>
    )
}

export default MyTimePicker